<script setup>
import {
  ArrowLeft,
  ArrowRight,
  Check,
  Sparkles,
  Rocket,
  Loader2,
} from 'lucide-vue-next';

defineProps({
  backLabel: {
    type: String,
    default: '',
  },
  backLabelShort: {
    type: String,
    default: '',
  },
  primaryLabel: {
    type: String,
    default: '',
  },
  primaryDisabled: {
    type: Boolean,
    default: false,
  },
  primaryLoading: {
    type: Boolean,
    default: false,
  },
  primaryVariant: {
    type: String,
    default: 'next',
  },
  hideBack: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['back', 'primary']);
</script>

<template>
  <div
    class="relative flex items-center gap-4 p-6 mt-6 bg-n-solid-2 border-t border-n-weak rounded-b-lg"
    :class="hideBack ? 'justify-end' : 'justify-between'"
  >
    <button
      v-if="!hideBack"
      type="button"
      class="flex items-center gap-2 h-12 px-6 rounded-xl font-semibold text-sm bg-white dark:bg-n-slate-3 text-n-slate-11 border border-n-weak hover:bg-n-slate-3 dark:hover:bg-n-slate-4 hover:border-n-slate-6 transition-all"
      @click="emit('back')"
    >
      <ArrowLeft class="w-4 h-4" />
      <span class="hidden sm:inline">{{ backLabel }}</span>
      <span class="sm:hidden">{{ backLabelShort || backLabel }}</span>
    </button>

    <div class="flex gap-3">
      <button
        type="button"
        :disabled="primaryDisabled || primaryLoading"
        class="flex items-center gap-2 h-12 px-6 rounded-xl font-bold text-sm text-white bg-n-teal-9 hover:bg-n-teal-10 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
        @click="emit('primary')"
      >
        <template v-if="primaryLoading">
          <Loader2 class="w-4 h-4 animate-spin" />
          {{ primaryLabel }}
        </template>
        <template v-else-if="primaryVariant === 'confirm'">
          <Check class="w-4 h-4" />
          {{ primaryLabel }}
          <Sparkles class="w-4 h-4" />
        </template>
        <template v-else-if="primaryVariant === 'submit'">
          <Rocket class="w-4 h-4" />
          {{ primaryLabel }}
        </template>
        <template v-else>
          {{ primaryLabel }}
          <ArrowRight class="w-4 h-4" />
        </template>
      </button>
    </div>
  </div>
</template>
